import * as _ from 'lodash';

/**
 * @typedef { import('../objects/Attendance').Attendance } Attendance
 * @typedef { import('../objects/Person').PersonEarning } PersonEarning
 */

export class EmployerOptions {
    /**
     * @param {string} name
     * @param {PersonEarning} earning
     */
    constructor(name, earning) {
        this.name = name;
        this.earning = earning;
    }

    /**
     * @param {Attendance} attendance
     * @returns {EmployerOptions[]}
     */
    static fromAttendance(attendance) {
        const date = attendance.Meeting.Date;
        const person = attendance.getPerson();
        if (person == null) {
            return [];
        }
        const groups = _.groupBy(person.Earnings, x => x.EmployerName);
        const options = _.map(groups, (earnings, name) => {
            let earningAtDate = _.find(earnings, x => x.ValidFrom <= date && (x.ValidTo == null || date <= x.ValidTo));
            return new EmployerOptions(name, earningAtDate);
        });
        return _.filter(options, x => x.earning);
    }
}
